import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Onboarding() {
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { auth, setAuth } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/company", { name });
      setAuth(data);
      navigate("/dashboard");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md border rounded-xl bg-card p-8 fade-in">
        <h1 className="text-2xl font-bold tracking-tight mb-1">Welcome{auth?.user?.name ? `, ${auth.user.name}` : ""}</h1>
        <p className="text-sm text-muted-foreground mb-6">Create your company to get started. You'll be the Owner.</p>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="company">Company name</Label>
            <Input id="company" data-testid="onboarding-company-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Kusina Group PH" required />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="onboarding-error">{error}</p>}
          <Button type="submit" className="w-full" disabled={loading || !name} data-testid="onboarding-submit-btn">
            {loading ? "Creating…" : "Create company"}
          </Button>
        </form>
      </div>
    </div>
  );
}
